<template>
   <!-- Footer -->
		<footer id="footer" class="out-sec">
      <!-- 2025.12.16 송준형 : REQSDP-9211 - [pcmall]Developer URL 적용 위한 글로벌 앱 리스트 페이지 신규개발 -->
			<div class="in-sec" v-if="allAppsYn == 'N'">
				<!-- Footer Nav -->
				<div class="fnb-wrap">
					<ul class="fnb">
						<li><router-link to="/main/terms"><span role="text" v-html="$t('sdp.menu.device.terms_condition')"></span></router-link></li>
						<!-- REQSDP-3622 : 2023.10.31 송준형 - [pcmall] pc website webOS Auto 차량용 약관 page update 요청 件 -->
						<li v-if="termsAutoYn == 'Y'"><router-link to="/main/termsAuto"><span role="text" v-html="$t('sdp.menu.device.auto_terms_condition')"></span></router-link></li>
						<!-- C20200923_07191 : 2020.09.24 송준형 - Shop Time 약관 반영 요청드립니다. -->
						<!-- REQSDP-1166 : 2021.10.28 송준형 - [PCMall]ShopTime 약관 국가 확산에 따른 pc website 약관 추가요청 -->
						<li v-if="shopTimeYn == 'Y'"><router-link to="/main/shopTime"><span role="text" v-html="$t('sdp.menu.shoptime.link')"></span></router-link></li>
						<!-- 2026.07.17 : REQSDF-9432 - [pcmall] LG Movies & TV Terms & Conditions (US) -->
						<li v-if="cntryCode == 'US'"><router-link to="/main/tvod"><span role="text" v-html="$t('sdp.menu.tvod.link')"></span></router-link></li>
						<!-- C20190723_47503 : 2019.08.08 김남중 - Safari 에서 javascript:; 미지원으로 terms/privacy뜨지 않는 오류 개선 (별도 csr 없이 N20190722_09499 이 csr과 함께 반영) -->
						<!-- C20200706_63912 : 2020.07.06 송준형 - [UI기획]PC website 웹접근성 심사 결과 모바일 대응 -->
						<li><a href="javascript:;" :title="$t('gwa.alt.common.wa_title_4')" @click="goLgTerms('SVC')" v-html="$t('sdp.menu.terms_condition')"></a></li>
						<!-- C20190827_72186 : 2019.08.29 김남중 - PC Mall 페이지 하단 Footer 개인정보처리방침  Bold 처리 - class="fontBold" 추가  -->
						<!-- C20200706_63912 : 2020.07.06 송준형 - [UI기획]PC website 웹접근성 심사 결과 모바일 대응 -->
						<li><a href="javascript:;" :title="$t('gwa.alt.common.wa_title_4')" @click="goLgTerms('PRV')" v-html="$t('sdp.menu.privacy')" class="fontBold"></a></li>
						<!-- C20200615_50615 : 2020.06.23 송준형 START -->
						<!--<li><a href="javascript:;" @click="goLgTerms('GA')" v-html="$t('sdp.menu.ga.link')"></a></li>-->
						<li><router-link to="/main/ga"><span role="text" v-html="$t('sdp.menu.ga.link')"></span></router-link></li>
						<!-- C20200615_50615 : 2020.06.23 송준형 END -->
						<li v-if="cntryCode == 'FR'"><a href="javascript:;" @click="goLgTerms('POPUP')" v-html="$t('sdp.menu.device.terms.link')"></a></li>
					</ul>
				</div>
				<!-- //Footer Nav -->
				
				<!-- Information -->
				<div v-show="cntryCode != 'AT'" class="info-wrap" v-html="$t('sdp.menu.footer.copyright')">
				</div>
				<div v-show="cntryCode == 'AT'" class="info-wrap" v-html="$t('sdp.menu.footer.copyright.AT')">
				</div>
				<!-- <div class="info-wrap" v-html="copyrightCheck">
				</div> -->
				<!-- //Information -->

				<!-- FamilySite -->
				<!-- 고도화 ver2 : 속성 title="새창" 추가 -->
				<div class="familySite-wrap">
					<div class="dropdown-wrap dropdown-familySite">
						<a href="#familySiteDrop" class="dropdown-toggle" role="button" aria-controls="familySiteDrop" aria-expanted="false">
              <!-- REQSDP-10103 : 2026.03.09 송준형 - [pcmall] ru.lgappstv.com 러시아 자국어 강화법_영문 텍스트, 이미지 교체건 -->
              <span v-if="cntryCode != 'RU'">FAMILYSITE <i class="arw arw-toggle2 centered-r"></i></span>
              <span v-else>Семейные сайты <i class="arw arw-toggle2 centered-r"></i></span>
            </a>
						<div id="familySiteDrop" class="dropdown">
							<span class="blind-area dropdown-focus" role="text" aria-labeledby="familySiteOpen"></span>
							<ul class="dropdown-menu">
								<li><a href="http://www.lg.com/common/index.jsp" class="dropdown-item" target="_blank" :title="$t('gwa.alt.common.wa_title_4')" v-html="$t('sdp.main.main.website')"></a></li>
								<li><a href="http://seller.lgappstv.com/seller/main/Main.lge" class="dropdown-item" target="_blank" :title="$t('gwa.alt.common.wa_title_4')">{{ $t('sdp.menu.seller_guide') }}</a></li>
								<li><a href="http://webostv.developer.lge.com" class="dropdown-item" target="_blank" :title="$t('gwa.alt.common.wa_title_4')">{{ $t('sdp.menu.developer_guide') }}</a></li>
							</ul>
						</div>
					</div>
				</div>
				<!-- //FamilySite -->

				<!-- WA Mark -->
        <!-- 2025.06.24 송준형 : REQSDP-7760 - [pcmall] 한국 lgappstv.com 웹접근성 로고 적용 -->
				<div v-show="langCode == 'kor'" class="mark-wrap">
					<a href="https://www.msit.go.kr/" title="새창열림" target="_blank"><img src="/img/cmn/ico_waMark.png" alt="과학기술정보통신부 WA(WEB ACCESSIBLITY) Mark" /></a><!-- 2022.03.11 inline style 삭제 jkw -->
				</div>
				<!-- //WA Mark -->

				<!-- start-2023.06.14 송준형 : REQSDP-2913 - [pcmall] PC website 웹접근성 심사 결과 대응_2023년 -->
				<!-- 팝업_FR국가 법적고지(NOTES JURIDIQUES) PC Website UI/UX개선 - N20190904_01409 : 2019.09.26 김남중 -->
				<!--<div v-show="cntryCode == 'FR'">-->
					<!--<TermsPop></TermsPop>-->
				<!--</div>-->
				<!-- //팝업_FR국가 법적고지(NOTES JURIDIQUES) PC Website UI/UX개선 - N20190904_01409 : 2019.09.26 김남중 -->
				<!-- end-2023.06.14 송준형 : REQSDP-2913 - [pcmall] PC website 웹접근성 심사 결과 대응_2023년 -->
				
			</div>
      <!-- 2025.12.16 송준형 : REQSDP-9211 - [pcmall]Developer URL 적용 위한 글로벌 앱 리스트 페이지 신규개발 -->
      <div class="in-sec" v-else>
        <div v-show="cntryCode != 'AT'" class="info-wrap" v-html="$t('sdp.menu.footer.copyright')">
        </div>
        <div v-show="cntryCode == 'AT'" class="info-wrap" v-html="$t('sdp.menu.footer.copyright.AT')">
        </div>
      </div>
		</footer>
	<!-- //Footer -->
</template>

<script>

    import qs from "qs";

    export default {
      name: "Footer",
      data() {
        return {
            isLogin: false,
			langCode: _domainLangCode,
			cntryCode: _domainCntryCode,
      allAppsYn: _allAppsYn, // 2025.12.16 송준형 : REQSDP-9211 - [pcmall]Developer URL 적용 위한 글로벌 앱 리스트 페이지 신규개발
			iosFlag: 0, // ios:11, ipad:12, ipop:13, .... 20:mac(mac관련은 11~20 까지), 이외는 모두 1~10(android, window, chrome, explo...)
			footerPopCnt: 0,
            shopTimeYn: "N", // 2021.10.28 송준형 : REQSDP-1166 - [PCMall]ShopTime 약관 국가 확산에 따른 pc website 약관 추가요청
			termsAutoYn: "N" // 2023.10.31 송준형 : REQSDP-3622 - [pcmall] pc website webOS Auto 차량용 약관 page update 요청 件
        }
      },
      created() {
      },
      watch: {
      },
      computed: {
          copyrightCheck() {
			  var copyRight = this.$t('sdp.menu.footer.copyright.'+ _domainCntryCode);
			  console.log("copyRight", copyRight);
			  if (copyRight == 'sdp.menu.footer.copyright.'+ _domainCntryCode) {
				  return this.$t('sdp.menu.footer.copyright');
			  } else {
			      return copyRight;
			  }
		  }
      },
      mounted() {
    	// start- C20190723_47503 : 2019.08.08 김남중 - Safari 에서 javascript:; 미지원으로 terms/privacy뜨지 않는 오류 개선 (별도 csr 없이 N20190722_09499 이 csr과 함께 반영)
  		//   - ios:11, ipad:12, ipop:13, .... 20:mac(mac관련은 11~20 까지), 이외는 모두 1~10(android, window, chrome, explo...)
  		const vm = this;
  		var varUA = navigator.userAgent.toLowerCase(); //userAgent 값 얻기
  		if (varUA.match('android') != null) { 
  		    //안드로이드 일때 처리
  			vm.iosFlag = 1;
  		} else if (varUA.indexOf("iphone") > -1 || varUA.indexOf("ipad") > -1 || varUA.indexOf("ipod") > -1) { 
  		    //IOS 일때 처리
  		    if (varUA.indexOf("iphone") > -1) {
  		    	vm.iosFlag = 11;
  		    } else if (varUA.indexOf("ipad") > -1) {
  		    	vm.iosFlag = 12;
  		    } else if (varUA.indexOf("ipod") > -1) {
  		    	vm.iosFlag = 13;
  		    } else {
  		    	vm.iosFlag = 21;
  		    }
  		} else {
  		    //아이폰, 안드로이드 모두 아닐때 처리....기타등등
  			if (varUA.indexOf("macintosh") > -1 || varUA.match(/mac|ppc/)) {
  				vm.iosFlag = 20;
  			} else {
  				vm.iosFlag = 0; // mac, ios를 제외한 것
  			}
  		}
  		// end- C20190723_47503 : 2019.08.08 김남중

          // start-2021.10.28 송준형 : REQSDP-1166 - [PCMall]ShopTime 약관 국가 확산에 따른 pc website 약관 추가요청
          var params = {
              cntryCode: _domainCntryCode,
              langCode: _domainLangCode
          };

          this.$axios.post('/api/terms/checkShopTimeTerms.ajax', qs.stringify(params)).then((result) => {
              vm.shopTimeYn = result.data.shopTimeYn;
              vm.termsAutoYn = result.data.termsAutoYn; // 2023.10.31 송준형 : REQSDP-3622 - [pcmall] pc website webOS Auto 차량용 약관 page update 요청 件
          }).catch((err) => {
              alert(err);
          });
          // end-2021.10.28 송준형 : REQSDP-1166 - [PCMall]ShopTime 약관 국가 확산에 따른 pc website 약관 추가요청
      },
      methods: {
          goLgTerms(type) {
       		  // start- C20190723_47503 : 2019.08.08 김남중 - Safari 에서 javascript:; 미지원으로 terms/privacy뜨지 않는 오류 개선 (별도 csr 없이 N20190722_09499 이 csr과 함께 반영)
       		  /* 이거 하지 않아도 잘 처리됨, safari 팝업찬단 및 아래의 window.open 문제이지만, 주석처리된 코드는 남겨둠
       		  if (this.iosFlag > 10) {
         	      var find = 'javascript:;';
         	      var re = new RegExp(find, 'g');
         	      document.body.innerHTML = document.body.innerHTML.replace(re, 'javascript:void(0);');
         	  } */
         	  // end- C20190723_47503 : 2019.08.08 김남중
              var params = {
                  cntryCode: _domainCntryCode,
				  langCode: _domainLangCode,
				  termsType: type
              };
         	  
         	  // start-PC Website UI/UX개선 - N20190904_01409 : 2019.09.26 김남중
         	  if (type == 'POPUP') {
         		  // ui.init() 이유는 한번 다른 페이지에서 팝업 오픈 하게 되면 popup이 content-body에 add되지 않아서 init을 한 후 popup을 open
         	      ui.popupp.open("popupRegalFr");
         	      return;
         	  }
              // end-PC Website UI/UX개선 - N20190904_01409 : 2019.09.26 김남중
              // start-PC Website 웹접근성 심사 결과 대응 - N20200612_04882 : 2020.06.23 송준형
         	 //  else if (type == 'GA') {
              //     ui.popup.open("popupGA");
              //     return;
              // }
              // end-PC Website 웹접근성 심사 결과 대응 - N20200612_04882 : 2020.06.23 송준형
              else {
         	      // window navigator
                  var userAgent = window.navigator.userAgent;
            	  var isChrome = userAgent.indexOf('Chrome');
            	  var isChromeMobile = userAgent.indexOf('CriOS');
            	  var isSamsungBrowser = userAgent.indexOf('SamsungBrowser');
            	  var isFirefox = userAgent.indexOf('Firefox');
            	  var isEdge = userAgent.indexOf('Edge');
            	  var browse = userAgent.toLowerCase();
            	  var isIe = browse.indexOf("msie");
            	  var isIeMinu = browse.indexOf("trident");
         	  	  // window Open
         	  	  // - Chrom/Firefox의 경우 간혹 "domain/_blank"로 되어 not found 후 emp이용약관으로 이동하여 현재 페이지open 후 이동하도록 처리함.
            	  // - PC 익스플로러는 팝업차단 우회 막혀서 안됨.
            	  var baseWinurl = window.location;
                  var termsUrl   = "";
         	  	  var termWindow;
                  //console.log("baseWinurl:", baseWinurl.origin);
         	  	  if ((navigator.appName == 'Netscape' && isIeMinu > -1) || isIe > -1) {}
         	  	  else if (isSamsungBrowser > -1) { termWindow = window.open(); }
         	  	  else if (isChrome > -1 || isFirefox > -1) { termWindow = window.open(baseWinurl, '_blank'); }
         	  	  else { termWindow = window.open('_blank'); }
         	  
	              this.$axios.post('/api/terms/retrieveTermsUrl.ajax', qs.stringify(params)).then((result) => {
	                  //this.openTermsUrl(result.data.termsUrl);
	                  // start-C20190723_47503 : 2019.08.08 김남중 - Safari 에서 javascript:; 미지원으로 terms/privacy뜨지 않는 오류 개선 (별도 csr 없이 N20190722_09499 이 csr과 함께 반영) :: window.location.protocol + window.location.host
	                  termsUrl = result.data.termsUrl;
	           	      
	                  // 브라우저 체크(IE의 경우 팝업 우회불가함.)
	            	  if ((navigator.appName == 'Netscape' && isIeMinu > -1) || isIe > -1) {
	            		  window.open(termsUrl, '_blank');
	            	  } else {
	            		  //var termWindow = window.open('_blank'); // C20190819_65828 : 2019.08.22 김남중 - PC Website Main Promotion Banner 링크 오류 수정 : about:blank -> _blank
	                      termWindow.location.href = termsUrl;
	            	  }
	                  
	            	  // mac, ios일 경우에만 parent refresh(reload) 처리한다.
	            	  // - safari의 경우 click이벤트 처리 후 브라우져상태 변경없음 처리되어 다음 Link Click시 이벤트가 처리되지 않아 현재 페이지를 refresh(reload) 처리함. 
	            	  if (this.iosFlag > 10) {
		            	  setTimeout(function() {
		            		  baseWinurl.reload();
		            		}, 500);
	            	  }
	            	  // end-C20190723_47503 : 2019.08.08 김남중 - Safari 에서 javascript:; 미지원으로 terms/privacy뜨지 않는 오류 개선 (별도 csr 없이 N20190722_09499 이 csr과 함께 반영)
	              }).catch((err) => {
	                  alert(err);
	              });
              }
              
          }/* ,// C20190819_65828 : 2019.08.22 김남중 - PC Website Main Promotion Banner 링크 오류 수정 : 주석처리
		  openTermsUrl(termsUrl) {
              window.open(termsUrl, "_blank");
		  } */
      }
    };
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>
